import template from './index.html.twig';
import './index.scss';

Shopware.Component.register('bf-amazon-connection-assistant-index', {
    template
});

